import React, {Component} from 'react';
import Slider from 'react-slick';
import _ from 'lodash';
import {css} from 'glamor';
import PreloadImage from '../components/PreloadImage';

const projectWrapper = css({
  margin: '20px 20px',
  marginBottom: '30px',
  paddingBottom: '30px',
  '@media(max-width: 500px)': {
    marginBottom: '60px',
  }
});
const sliderItem = css({
  maxHeight: '300px',
  display: 'flex',
  alignItems: 'center',
  marginRight: '10px',
  '@media(max-width: 500px)': {
    maxHeight: '300px',
  }
});
const sliderItemDescription = css({
  width: '300px',
  paddingRight: '10px',
  '@media(max-width: 500px)': {
    width: '250px',
    fontSize: '13px',
    lineHeight: '18px'
  }
});
const sliderItemImage = css({
  maxHeight: '300px',
  pointerEvents: 'none',
  '@media(max-width: 500px)': {
    maxHeight: '300px',
  }
});

const projectTitle = css({
  textTransform: 'uppercase',
  '@media(max-width: 500px)': {
    fontSize: '20px',
  }
})

const projectModal = css({
  position: 'fixed',
  zIndex: 999,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(255,255,255,.9)',
});
const projectInnerModal = css({
  margin: '60px 0',
  '@media(max-width: 500px)': {
    margin: '170px 0 0 0',
  }
});
const sliderItemModal = css({
  maxHeight: '600px',
  display: 'flex',
  alignItems: 'center'
});
const sliderItemImageModal = css({
  maxHeight: '600px',
  pointerEvents: 'none',
  margin: '0 auto',
});
const projectModalX = css({
  padding: '20px',
  position: 'absolute',
  top: 0,
  right: 0,
  fontSize: '20px',
  color: '#333',
  cursor: 'pointer'
});
class Project extends Component {

  componentDidMount() {
    this.slider.innerSlider.list.setAttribute('tabindex', 0);
    this.slider.innerSlider.list.focus();
  }

  render() {
    const project = this.props.project;
    const showDescription = false;
    const settings = {
      accessibility: true,
      dots: true,
      infinite: project.photos && project.photos.length > 3 ? false : false,
      variableWidth: true,
      touchThreshold: 5000,
      speed: 300,
      arrows: true,
    };
    return (
      <div {...projectWrapper}>
        {
          !showDescription ?
          <h3 {...projectTitle}>{project.title}</h3> : null
        }
        <div>
          <Slider {...settings} ref={(s) => this.slider = s}>
            {
              showDescription ?
              <div {...sliderItem} {...sliderItemDescription}>
                <h2 {...projectTitle}>{project.title}</h2>
                <p dangerouslySetInnerHTML={{__html: _.get(project, 'description.childMarkdownRemark.html')}}/>
              </div> : null
            }
            {
              _.map(project.photos, (photo, i) => {
                return (
                  <div key={photo.responsiveSizes.src} {...sliderItem} onClick={this.props.onShowImage.bind(this, i)}>
                    <PreloadImage styles={sliderItemImage} src={photo.responsiveSizes.src} srcSet={photo.responsiveSizes.srcSet}/>
                  </div>
                );
              })
            }
          </Slider>
        </div>
      </div>
    );
  }

}

class ProjectModal extends Component {

  componentDidMount() {
    if (this.slider) {
      this.slider.innerSlider.list.setAttribute('tabindex', 0);
      this.slider.innerSlider.list.focus();
    }
  }

  render() {
    const project = this.props.project;
    if (!project) {
      return null;
    }
    const showDescription = false;
    const settings = {
      accessibility: true,
      dots: true,
      infinite: project.photos && project.photos.length > 3 ? false : false,
      touchThreshold: 5000,
      speed: 300,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: this.props.activeIndex,
      className: 'modal-slider'
    };
    return (
      <div {...projectModal} onClick={() => this.props.closeModal()}>
        <div {...projectModalX}>&#x2715;</div>
        <div {...projectInnerModal} onClick={(e) => e.stopPropagation()}>
          <Slider {...settings} ref={(s) => this.slider = s}>
            {
              _.map(project.photos, (photo, i) => {
                return (
                  <div key={photo.responsiveSizes.src} {...sliderItemModal}>
                    <PreloadImage styles={sliderItemImageModal} src={photo.responsiveSizes.src} srcSet={photo.responsiveSizes.srcSet}/>
                  </div>
                );
              })
            }
          </Slider>
        </div>
      </div>
    );
  }

}

class ProtfolioPage extends Component {
  state = {
    activeIndex: 0,
    activeProject: null
  }
  render() {
    const projects = _.map(this.props.data.allContentfulProject.edges, (e) => e.node);
    return (
      <div>
        {
          _.map(projects, (project, i) => {
            return <Project
              key={project.title}
              project={project}
              onShowImage={(i) => {
                this.setState({activeIndex: i, activeProject: project})
              }}/>
          })
        }
        <ProjectModal
          project={this.state.activeProject}
          activeIndex={this.state.activeIndex}
          closeModal={this.closeModal.bind(this)}/>
      </div>
    );
  }

  closeModal() {
    this.setState({activeIndex: 0, activeProject: null})
  }

}
export default ProtfolioPage

export const query = graphql`
  query ProjectsQuery {
    allContentfulProject(sort: {fields: [date], order: ASC}) {
      edges {
        node {
          title,
          slug,
          description {
            childMarkdownRemark {
              html
            }
          },
          photos {
            responsiveSizes {
              aspectRatio
              src
              srcSet
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/portfolio.js